import React, { useEffect, useRef, useState } from 'react';
import { Table, Form, InputNumber } from 'antd';


const EditableContext = React.createContext(null);

const EditableRow = React.forwardRef(({ index, ...props }, ref) => {
  const [form] = Form.useForm();
  const formRef = useRef();

  React.useImperativeHandle(ref, () => ({
    getForm: () => {
      return formRef.current;
    },
  }));

  return (
    <Form ref={formRef} form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
});

class EditableCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: true,
    };
    this.inputRef = React.createRef();
  }

  save = async (e) => {
    const { record, handleSave } = this.props;
    const form = this.form;
    
    const errorValue = form.getFieldValue();
    try {
      const values = await form.validateFields();
      handleSave({ ...record, ...values }, true);
    } catch (errInfo) {
      handleSave({ ...record, ...errorValue }, false);
      console.log('Save failed:', errInfo);
    }
  };

  renderCell = ({ getFieldDecorator, getFieldValue }) => {
    const { editing } = this.state;
    const { title, editable, children, dataIndex, label, record, ...restProps } = this.props;
    // console.log('record====', record);
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>
            {(form) => {
              this.form = form;
              return editing ? (
                <Form.Item
                  // label={<span style={{color: 'red', marginRight: '5px'}}>*</span>}
                  style={{ margin: 0 }}
                  name={dataIndex}
                  rules={[
                    // {
                    //   required: true,
                    //   message: `${title} is required.`,
                    // },
                    {
                      pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                      message: label,
                    },
                  ]}
                >
                  {/* <span style={{color: 'red', marginRight: '5px'}}>*</span> */}
                  <InputNumber style={{width: '150px'}} defaultValue={record.price} ref={this.inputRef}  onBlur={this.save} />
                </Form.Item>
              ) : (
                <div
                  className="editable-cell-value-wrap"
                  style={{ paddingRight: 24 }}
                  onClick={this.toggleEdit}
                >
                  {children}
                </div>
              );
            }}
          </EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  };

  render() {
    return this.renderCell({});
  }
}


const EditableTable = React.forwardRef((props, ref) => {
  const [dataSource, setDataSource] = React.useState(props.dataSource);

  const columns  = props.columns;
  useEffect(()=>{
    if(props?.dataSource.length)setDataSource(props.dataSource)
  },[props])

  const handleSave = (row, flag) => {
      console.log('row---',row);
      const dataList = [...dataSource];
      const newList = dataList.map((item) =>{
        if(row.id === item.id){
          return {...row};
        }else{
          return {...item}
        }
      })
      setDataSource(newList);
  };


  const components = {
    body: {
      row: EditableRow,
      // cell: withTranslation()(EditableCell)
      cell: EditableCell,
    },
  };

  const columnsConfig = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        label: col.label,
        handleSave: handleSave,
      }),
    };
  });

  React.useImperativeHandle(ref, () => ({
    getList: () => {
      return dataSource
    },
  }));

  return (
    <Table
      components={components}
      rowClassName={() => 'editable-row'}
      bordered
      dataSource={dataSource}
      columns={columnsConfig}
      pagination={false}
    />
  );
});

const QuoTable = React.forwardRef((props, ref)=>{

  const [dataSource, setDataSource] = useState([]);
  const formRef = React.createRef();

  React.useImperativeHandle(ref, () => ({
    getList: () =>{
      return formRef.current.getList();
    } 
  }));

  useEffect(()=>{
    if(props.dataSource.length) setDataSource(props.dataSource)
  },[props])

  // const getFormInstance = () => {
  //   const form = formRef.current;
    
  //   console.log('---form', form);
  // };
  
  return (
    <div>
      {/* {props.t('tips', { defaultValue: '提示' })} */}
      <EditableTable ref={formRef} dataSource={dataSource} columns={props.columns} />
    </div>
  );
})
export default QuoTable
// export default withTranslation()(React.forwardRef(QuoTable));